import { Injectable, Injector } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ErrorModalComponent } from '../../shared/components/error-modal/error-modal.component';
import { TranslateService } from './translate.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorModalService {

  constructor(
    private dialog: MatDialog,
    private injector: Injector
  ) {}

  openErrorModal(messageKey: string, icon?: string): MatDialogRef<ErrorModalComponent> {
    // Usar Injector para obtener TranslateService de forma lazy y evitar dependencias circulares
    const translateService = this.injector.get(TranslateService);
    
    return this.dialog.open(ErrorModalComponent, {
      data: {
        icon: icon || 'error',
        title: translateService.translate('common.errors.title'),
        message: translateService.translate(messageKey),
        buttonText: translateService.translate('common.buttons.accept')
      },
      disableClose: true,
      panelClass: 'app-container-dialog',
    });
  }
}

